module.exports = __webpack_public_path__ + "static/Apercu-Bold-b62ffe759a247810bd1f6a6a2cbc3d0c.otf";